import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core';
import { getDate, setDate } from 'date-fns';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { DTRRuleConverted } from '../types';

import { isNotNil } from 'utils/ramdaUtils';

import { Rule } from './Rule';

const useStyles = makeStyles(() => ({
  alignment: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    paddingBottom: 15,
    marginTop: 15
  }
}));

export const RulesRenderer: React.FC = () => {
  const classes = useStyles();

  const { control, setValue, watch } = useFormContext<DTRRuleConverted>();
  const { fields: rules } = useFieldArray({ control, name: 'variables' });

  const endDate = watch('rules.nightShiftEndTime.value');

  useEffect(() => {
    const restThresh = watch('rules.nightShiftEndTimeRestThresh.value');
    if (isNotNil(restThresh)) {
      setValue(
        'rules.nightShiftEndTimeRestThresh.value',
        setDate(restThresh, getDate(endDate))
      );
    }
  }, [endDate]);

  return (
    <div className={classes.alignment}>
      {rules.map((rule) => (
        <Rule rule={rule} key={rule.ruleVariableName} />
      ))}
    </div>
  );
};
